import React from 'react'

export default function About() {
  return (
    <img className="h-full w-full" src={"/bio-page.png"} alt="bio page" id="aboutImg" />
  )
}
